module.exports = __webpack_public_path__ + "static/media/lcs_60yd_n-1.2aa1ecd2.csv";